import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const features = [{
  title: 'Respaldo Legal Real',
  desc: 'Documentación completa y organizada para trabajar con mayor seguridad ante inspecciones y auditorías.'
}, {
  title: 'Control Total de cada Cliente',
  desc: 'Toda la información de cada empresa en un solo lugar, siempre actualizada y fácil de encontrar.'
}, {
  title: 'Tranquilidad Profesional',
  desc: 'Dejá de crear documentos desde cero y dedicá ese tiempo a conseguir y atender más clientes.'
}, {
  title: 'Orden Sostenible',
  desc: 'Un sistema simple para mantener toda tu gestión organizada durante todo el año.'
}];
export function FeaturesSection() {
  return <section className="py-16 md:py-24 bg-transparent" data-id="element-49">
      <div className="container mx-auto px-4 max-w-2xl" data-id="element-50">
        <div className="text-center mb-10" data-id="element-51">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-[#2f3a2c]" data-id="element-52">
            ¿QUÉ VAS A LOGRAR CON ESTE SISTEMA?
          </h2>
        </div>

        <ul className="space-y-4" data-id="element-53">
          {features.map((feature, i) => <motion.li key={i} initial={{
          opacity: 0,
          y: 8
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} className="flex items-start gap-3" data-id="element-54">
              <CheckCircle2 className="w-5 h-5 text-[#d4a017] flex-shrink-0 mt-1" data-id="element-55" />
              <p className="text-slate-600 leading-relaxed" data-id="element-56">
                <span className="font-bold text-[#2f3a2c]" data-id="element-57">
                  {feature.title}
                </span>
                {' — '}
                {feature.desc}
              </p>
            </motion.li>)}
        </ul>
      </div>
    </section>;
}